import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(undefined, "europe-west2");

const callFunction = async (name, payload = {}) => {
  const callable = httpsCallable(functions, name);
  const response = await callable(payload);
  return response.data || {};
};

export const listMuxVideos = (payload = {}) =>
  callFunction("adminListMuxVideos", payload);

export const createMuxUpload = (payload) =>
  callFunction("adminCreateMuxUpload", payload);

export const updateMuxVideo = (payload) =>
  callFunction("adminUpdateMuxVideo", payload);

export const archiveMuxVideo = (payload) =>
  callFunction("adminArchiveMuxVideo", payload);

export const deleteMuxVideo = (payload) =>
  callFunction("adminDeleteMuxVideo", payload);

export const getMuxPlaybackDescriptor = (payload) =>
  callFunction("getMuxPlaybackDescriptor", payload);

export const getMuxVideoDisplayName = (video) =>
  video?.displayName || video?.legacyFirebasePath || video?.id || "";

export const getMuxVideoStatusColor = (status) => {
  switch (status) {
    case "ready":
      return "success";
    case "preparing":
    case "waiting_for_upload":
    case "pending_upload":
    case "needs_import":
      return "warning";
    case "errored":
      return "error";
    case "archived":
      return "grey";
    default:
      return "info";
  }
};
